var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframeClass"},[_c('iframe',{staticClass:"iframeClass",attrs:{"id":"iframe","src":_vm.visualSrc,"frameborder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }